import axios from "@/common/http";

export default {
  state: () => ({}),
  mutations: {},
  actions: {
    /**
     * @desc 统一文件上传 目前图片只能单张上传（没有裁剪功能）
     * @param {*} file
     * @returns
     */
    async publicUploadFile({ commit }, file) {
      console.log(commit);
      const res = await axios.post("/v1/upload/pic", file);
      return res;
    },
  },
  getters: {},
};
